"use strict";

var _regeneratorRuntime = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignatureValidator = void 0;

var eth_connect_1 = require("eth-connect");

function SignatureValidator(_x, _x2) {
  return _SignatureValidator.apply(this, arguments);
}

function _SignatureValidator() {
  _SignatureValidator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestManager, address) {
    var abi;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            abi = [{
              constant: true,
              inputs: [{
                name: 'hash',
                type: 'bytes32'
              }, {
                name: '_signature',
                type: 'bytes'
              }],
              name: 'isValidSignature',
              outputs: [{
                name: 'magicValue',
                type: 'bytes4'
              }],
              payable: false,
              stateMutability: 'view',
              type: 'function'
            }];
            _context.next = 3;
            return new eth_connect_1.ContractFactory(requestManager, abi).at(address);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _SignatureValidator.apply(this, arguments);
}

exports.SignatureValidator = SignatureValidator;